export default "__VITE_ASSET__5db28e03__"